import React, { useContext, useEffect, useState } from 'react'
import { MdStore } from 'react-icons/md'

import { Grid, LinearProgress } from '@material-ui/core'
import PropTypes from 'prop-types'
import changeLogo from '../../assets/images/altera-logo.png'
import ButtonGZ from '../../components/Button'
import ToastMessages from '../../components/ToastMessages'
import TopSearch from '../../components/TopSearch'
import Context from '../../context'
import { createScript, getScriptList, getSearch } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

function ScriptsList({ location }) {
  const { state } = location
  const { setUser, setOpenToast, setAboutCurrentPage } = useContext(Context)
  const [scriptList, setScriptList] = useState([])
  const [fullScriptList, setFullScriptList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [searchData, setSearchData] = useState({ str: '', startSearch: false })
  const [publicLoading, setPublicLoading] = useState({
    loading: false,
    objectId: 0
  })

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser())
    } else {
      history.replace('/')
    }
    setAboutCurrentPage({
      title: 'Roteiros',
      buttons: [{ title: 'Adicionar Roteiro', pathname: '/scriptform' }]
    })
    getScriptList().then(r => {
      if (r) {
        let user = getLoggedUser()
        let neededData =
          user?.userGroup !== 6
            ? r
            : r.filter(
                item =>
                  item.ScriptsWhiteLabels?.length === 1 &&
                  item.ScriptsWhiteLabels[0].whiteLabelId === user.whiteLabelId
              )
        setScriptList(neededData)
        setFullScriptList(neededData)
        setIsLoading(false)
      }
    })

    if (state && state.showToast) {
      setOpenToast({
        open: true,
        message: state.toastMessage,
        type: 'success'
      })
    } else {
      setOpenToast({
        open: false,
        message: '',
        type: 'success'
      })
    }
  }, [])

  useEffect(() => {
    if (searchData.startSearch) {
      setIsLoading(true)
      getSearch('scripts', searchData.str).then(r => {
        if (r) {
          setScriptList(r)
          setSearchData({ ...searchData, startSearch: false })
          setIsLoading(false)
        } else {
          setScriptList([])
        }
      })
    }

    if (!searchData.startSearch && searchData.str === '') {
      setScriptList(fullScriptList)
    }
  }, [searchData])

  let erroMessage = ''
  ;(() => {
    try {
      scriptList.map(item => item)
    } catch (err) {
      erroMessage = React.createElement(
        'div',
        { className: 'container' },
        <ButtonGZ color="primary" onClick={() => history.go(0)}>
          Atualize a página!
        </ButtonGZ>
      )
      console.log(err)
    }
  })()

  const checkLoading = id => {
    return publicLoading.loading && publicLoading.objectId === id
  }

  const handlePublicClick = async id => {
    setPublicLoading({ loading: true, objectId: id })
    const itemToChange = scriptList.find(item => item.id === id)
    const active = await createScript({
      id: itemToChange.id,
      situation: itemToChange.situation === 3 ? 1 : 3,
      scriptsWhiteLabels: itemToChange.ScriptsWhiteLabels
    })

    if (active.id) {
      setScriptList(list => {
        return list.map(item => {
          if (item.id === id) {
            const situation = item.situation === 3 ? 1 : 3
            return { ...item, situation }
          }
          return item
        })
      })

      setPublicLoading({ loading: false, objectId: 0 })
      setOpenToast({
        open: true,
        message: 'Script atualizado com sucesso',
        type: 'success'
      })
    } else {
      setOpenToast({
        open: true,
        message: 'Ocorreu algum erro ao atualizar.',
        type: 'error'
      })
    }
  }

  const handleEditClick = id => {
    const scriptToEdit = scriptList?.find(item => item.id === id)
    history.push('/scriptform', { scriptToEdit })
  }

  return (
    <div className="container-fluid h-100">
      <Grid container xs={12} style={{ padding: 15 }}>
        <Grid item xs={12} justify="center">
          <ToastMessages />
          <Context.Provider value={{ searchData, setSearchData }}>
            <TopSearch />
          </Context.Provider>
        </Grid>
        <Grid item xs={12} justify="center">
          {isLoading ? (
            <LinearProgress marginTop="30px" />
          ) : (
            <div className="row">
              {Array.from(scriptList).map(script => (
                <div
                  key={script.id}
                  className="col-lg-3 col-md-6 col-sm-12"
                  style={{ padding: 10 }}
                >
                  <div className="card card-clube">
                    <img
                      className="card-img-top "
                      src={
                        script.image !== ''
                          ? `${process.env.REACT_APP_IMAGES_URL}${script.image}`
                          : changeLogo
                      }
                      alt={script.title1 || ''}
                    />

                    <div className="card-body">
                      <h4
                        className="card-title w-100 d-flex justify-content-between align-content-center"
                        style={{ minHeight: 60 }}
                      >
                        {`${script.title1 || ''} ${script.title2 || ''}`}
                        {script.situation === 3 && (
                          <small style={{ fontSize: 12, color: 'red' }}>Rascunho</small>
                        )}
                        {script.situation === 1 && (
                          <small style={{ fontSize: 12, color: 'green' }}>Publicado</small>
                        )}
                      </h4>
                      <div style={{ minHeight: 50 }}>
                        <p>
                          <MdStore style={{ marginRight: 10 }} />
                          {script.ScriptPartnerLists.length} Locais
                        </p>
                      </div>
                    </div>

                    <div className="card-body d-flex align-content-center justify-content-between flex-grow-0">
                      <button
                        disabled={checkLoading(script.id)}
                        className={`card-link btn ${
                          script.situation === 3 ? 'btn-success' : 'btn-danger'
                        }`}
                        onClick={() => handlePublicClick(script.id)}
                        type="button"
                      >
                        {script.situation === 3 ? 'Publicar' : 'Desativar'}
                      </button>

                      <button
                        className=" card-link btn clube-btn clube-blue "
                        type="button"
                        onClick={() => handleEditClick(script.id)}
                      >
                        Editar
                      </button>
                    </div>
                    {checkLoading(script.id) && <LinearProgress marginBottom="10px" />}
                  </div>
                </div>
              ))}
            </div>
          )}
        </Grid>
      </Grid>
      {erroMessage}
    </div>
  )
}

ScriptsList.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.object
  }).isRequired
}

export default ScriptsList
